<div class="four_zero_four_page">
    <div class="page_wrap_sections">
        <div class="left_side_secitons">
            <div class="circle_sections">
                <h2>404</h2>
                <p>无法找到页面</p>
            </div>
        </div>
        <div class="right_side_secitons">
            <h2>不好了！</h2>
            <h3>我们上天下海还是找不到您要前往的页面。</h3>
            <p>您使用的连结可能已过期、发生错误、或您没有访问权限。</p>
            <button [routerLink]="['']">回到首页</button> 
        </div>
    </div>
</div>
